import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Select, Spin} from "antd"
import {listSizeBySku} from "../../../../../services/api/3dApi"

const {Option} = Select

class FilterSizes extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            options: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.id !== prevProps.id) {
            this._fetchSizes()
        }
    }

    componentDidMount() {
        if (this.props.id !== '' && !!this.props.id) {
            this._fetchSizes()
        }
    }

    _fetchSizes = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {id} = this.props

            const {data: response} = await listSizeBySku(id)

            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                options: data
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleChangeSize = (value) => {
        const {onChange} = this.props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    render() {
        const {defaultValue} = this.props
        const {options, loading, error} = this.state
        const listOptions = options.length > 0 && options.filter(item => item.sku !== 'DEFAULT')

        return (
            error ? <Alert message={error} type={'error'}/> :
                <div className='FilterSizes mt-1'>
                    <Spin spinning={loading}>
                        <div className='btn-group btn-group-toggle'>
                            <Select value={defaultValue} style={{width: 200}} onChange={this._handleChangeSize}>
                                <Option value={''}>-- Chọn size --</Option>
                                {
                                    listOptions.length > 0 && listOptions.map((size) => {
                                        return <Option key={size._id} value={size.sku}>{size.sku}</Option>
                                    })
                                }
                            </Select>
                        </div>
                    </Spin>
                </div>
        )
    }
}

FilterSizes.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default FilterSizes
